import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { Icon, IconName } from './Icon';
import { haptic } from '@/lib/telegram';

const TABS: { to: string; label: string; icon: IconName }[] = [
  { to: '/campaigns', label: 'Кампании', icon: 'home' },
  { to: '/accounts',  label: 'Аккаунты', icon: 'users' },
  { to: '/profile',   label: 'Профиль',  icon: 'settings' },
];

export function TabBar(): JSX.Element {
  return (
    <nav className="tabbar">
      <div className="tabbar-inner">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) => clsx('tab-item', isActive && 'tab-item-active')}
            onClick={() => haptic('light')}
          >
            {({ isActive }) => (
              <span className="flex items-center gap-2 px-3 py-1">
                <Icon name={t.icon} size={18} />
                {isActive && <span className="text-[11px]">{t.label}</span>}
              </span>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
